<div class="p-4 md:p-6 max-w-5xl mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">currency_exchange</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Tasa de negociación USDT</h1>
  </div>

  <!-- Candado de edición (solo producción). Ver AdminEditPermissionsService -->
  <app-solo-lectura-banner *ngIf="!puedeEditar"
    detalle="La edición de la tasa de negociación USDT y del factor de seguridad está reservada al operador autorizado.">
  </app-solo-lectura-banner>

  <!-- Tasa actual + Factor manual -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <!-- Card tasa actual -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="tasa">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">show_chart</mat-icon>
          Tasa actual
        </h2>
      </div>
      <div class="p-5 flex flex-col items-center gap-4">
        <p class="text-3xl font-bold" style="color: #1e5a3f;">{{ tasa.tasaUsdtClp | currency:'':'':'1.2-2' }}</p>
        <span class="text-xs text-gray-400 uppercase font-semibold">CLP / USDT</span>
        <button type="button" [disabled]="!puedeEditar"
          [style.opacity]="puedeEditar ? '1' : '0.5'"
          [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'" (click)="setRates()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">edit</mat-icon>
          Actualizar tasa
        </button>
      </div>
    </div>

    <!-- Card factor manual -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">tune</mat-icon>
          Factor de seguridad manual
        </h2>
      </div>
      <div class="p-5">
        <form *ngIf="formCuenta" [formGroup]="formCuenta" class="flex flex-col items-center gap-4">
          <mat-form-field appearance="outline" class="modern-field w-full" style="max-width: 200px;">
            <mat-label>Factor Manual</mat-label>
            <input type="text" matInput appOnlynumber formControlName="factorManual" placeholder="Ingresa el factor">
            <mat-error *ngIf="formCuenta.get('factorManual')?.errors?.['greaterThanZero']">
              Debe ser mayor que 0
            </mat-error>
            <mat-error *ngIf="formCuenta.get('factorManual')?.hasError('maxlength')">
              Debe tener menos de 3 caracteres
            </mat-error>
          </mat-form-field>
          <button type="button" [disabled]="!puedeEditar"
          [style.opacity]="puedeEditar ? '1' : '0.5'"
          [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'" (click)="actualizarFactorManual()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
            Actualizar Factor
          </button>
        </form>
      </div>
    </div>
  </div>

  <!-- Historial -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;"
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">history</mat-icon>
        Historial de la tasa de negociación
      </h2>
      <button type="button" (click)="reload()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">refresh</mat-icon>
        Refrescar
      </button>
    </div>

    <div class="px-4 pt-2">
      <mat-paginator #paginator
        (page)="onPageChange($event)"
        [length]="totalItems"
        [pageSize]="pageSize"
        [disabled]="false"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [hidePageSize]="false"
        [pageIndex]="currentPage-1"
        aria-label="Select page">
      </mat-paginator>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto" *ngIf="dataSource">
      <table mat-table [dataSource]="dataSource" class="w-full">
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs">{{ row.createdAt | date:'dd/MM/yyyy' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="hora">
          <th mat-header-cell *matHeaderCellDef>Hora</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs">{{ row.createdAt | date:'hh:mm a':'America/Santiago' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="tasa">
          <th mat-header-cell *matHeaderCellDef>Tasa de Negociación</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs font-bold" style="color: #1e5a3f;">
              {{ row.tasaUsdtClp ? (row.tasaUsdtClp | number:'1.2-2') : '' }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden space-y-3 p-4" *ngIf="dataSource">
      <div *ngFor="let row of dataSource.filteredData; let i = index"
        class="bg-white rounded-xl shadow-sm border border-gray-200 p-3">
        <div class="flex items-center justify-between">
          <div class="text-xs text-gray-500">
            <span class="font-semibold">{{ row.createdAt | date:'dd/MM/yyyy' }}</span>
            <span class="ml-2 text-gray-400">{{ row.createdAt | date:'hh:mm a':'America/Santiago' }}</span>
          </div>
          <span class="text-sm font-bold" style="color: #1e5a3f;">
            {{ row.tasaUsdtClp ? (row.tasaUsdtClp | number:'1.2-2') : '' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
